import { vuexfireMutations } from 'vuexfire'
import { db } from '@/plugins/firebase'

export default {
  SET_LOGGED_IN (state, value) {
    state.user.loggedIn = value
  },
  SET_USER (state, data) {
    state.user.data = data
  },
  EDIT_USER (state, data) {
    state.editappart = data
  },
  EDIT_APPART (state, data) {
    state.editappart = data
  },
  EDIT_ACTUALITE  (state, data) {
    state.editactualite = data
  },
  EDIT_DEVIS  (state, data) {
    state.editdevis = data
  },
  EDIT_REALISATION  (state, data) {
    state.editrealisation = data
  },
  EDIT_IMGZOOM  (state, data) {
    state.editimgzoom = data
  },
  CLOSE_MODAL (state, modal) {
    state['modal' + modal] = false
  },
  SHOW_MODAL (state, modal) {
    if (modal === 'Editdevis' || modal === 'Viewdevis') {
      if (state.editdevis.publie === 'new') {
        db.collection('devis')
          .doc(state.editdevis.id)
          .update({ publie: 'vu' })
          .then(function () {
            console.log('Document vue!')
          }).catch(function (error) {
            console.error('Erreur de suppression du document: ', error)
          })
      }
    }
    state['modal' + modal] = true
  },
  ...vuexfireMutations
}
